var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row"},[_vm._l((_vm.charts),function(chart){return [_c(chart.type,{key:chart.id,tag:"component",attrs:{"data":chart.data}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }